import { render } from "./01_AboutUs.vue?vue&type=template&id=332f30de&scoped=true"
import script from "./01_AboutUs.vue?vue&type=script&lang=js"
export * from "./01_AboutUs.vue?vue&type=script&lang=js"

import "./01_AboutUs.vue?vue&type=style&index=0&id=332f30de&lang=css"
import "./01_AboutUs.vue?vue&type=style&index=1&id=332f30de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332f30de"]])

export default __exports__